import { ConfigObj, ScrollTo, DomHelpers } from '../utils/'

const defaultOpts = {
  offset: 0,
  offsetElement: '',
  element: ''
}

export default class ScrollToAnchor {
  constructor($el, opts) {
    this.$el = $el
    this.opts = ConfigObj.merge(defaultOpts, opts)
  }

  init() {
    if (DomHelpers.isValidSelector(this.opts.offsetElement)) {
      const $offsetEl = document.querySelector(this.opts.offsetElement)
      if ($offsetEl != null) this.opts.offset = this.opts.offset + $offsetEl.offsetHeight
    }

    this.setAnchorElementId()
    this.addEventListeners()
  }

  setAnchorElementId() {
    if (DomHelpers.isValidSelector(this.opts.element)) {
      const $element = document.querySelector(this.opts.element)
      if ($element == null) return

      $element.id = `scrollTo_${+new Date()}`
      this.$elementId = $element.id
    }
  }

  scrollToAnchor(e) {
    ScrollTo(`#${this.$elementId}`, this.opts.offset)
    e.preventDefault()
  }

  addEventListeners() {
    this.$el.addEventListener('click', this.scrollToAnchor.bind(this))
  }
}



// WEBPACK FOOTER //
// ./js/modules/ScrollToAnchor.js